import React from "react";
import { fetchMainNavigation } from "@/sanity/lib/queries";
import HeaderClient from "./HeaderClient";
import type { NavigationItem } from "@/types/navigation";

/**
 * Server component that fetches navigation data and passes it to client component
 */
export default async function Header() {
  const navData = await fetchMainNavigation();

  // Process navigation items: combine navigation document links with page references
  const navigationItems: NavigationItem[] = [];

  // Add links from navigation document if it exists
  if (navData.navigation?.links && navData.navigation.links.length > 0) {
    navData.navigation.links.forEach((link) => {
      navigationItems.push({
        label: link.label,
        href: link.url,
        external: link.external || false,
      });
    });
  }

  const isHomeItem = (item: NavigationItem) =>
    item.href === "/" || item.label.trim().toLowerCase() === "home";
  const isTopNavExcluded = (item: NavigationItem) => {
    const label = item.label.trim().toLowerCase();
    return (
      item.href === "/consulting" ||
      label === "consulting" ||
      item.href === "/case-studies" ||
      label === "case studies" ||
      item.href === "/products" ||
      label === "products" ||
      item.href === "/resume" ||
      label === "resume"
    );
  };

  if (!navigationItems.some(isHomeItem)) {
    navigationItems.unshift({ label: "Home", href: "/", external: false });
  }

  return (
    <HeaderClient
      navigationItems={navigationItems.filter((item) => !isTopNavExcluded(item))}
    />
  );
}
